module.exports = __webpack_public_path__ + "media/fonts/SFProText-Semibold-6bbce5e2d2d245ad3c042dad9f5c104c.woff2";